import {baseUrl} from "../http/baseUrl";
import {post, get} from "../http/http";
let currentUrl = baseUrl + '/report/unify/query'
/**params: 搜索入参*/
/**params.type:
 * Year     年
 * Quarter  季度
 * Month    月
 * */
/** module:
 * trendAnalysis 专利趋势分析
 * applicantAnalysis 申请人分析
 */
/**block:
 * title      头部统计数据
 * accredit   专利授权态势分析
 * increase   专利增长态势分析
 * */
export const getPatentStatisticalAnalysis = (params,module,block) => {
  let url = currentUrl + `/clickhouse-${module}-${block}`
  if(params.type){
    url += params.type
  }
  return get(url, params);
}
export const getPatentStatisticalAnalysisDict = (module,block) => {
  return get(currentUrl + `/clickhouse-${module}-${block}`);
}
export const getEnterpriseList = (params) => {
  let url = currentUrl + `/clickhouse-area-enterpriseDict`
  return get(url, params);
}




// WEBPACK FOOTER //
// ./src/plugins/api/PatentStatisticalAnalysis.js